const divModalEquipService = {
  text: 'Selecione um Site'
};

export default divModalEquipService;
